import { Col, Divider, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import { rub } from '../../../../../shared/contants/styles';

const { Text, Link } = Typography;

export const getModalContent = data => {
    return [
        { name: 'Дата заказа', value: data?.created_at, type: 'date' },
        { name: 'Статус', value: data?.status_name },
        {
            name: 'Общая стоимость',
            value: data?.total_order_sum,
            type: 'price',
        },
        { name: 'Сумма заказа', value: data?.total, type: 'price' },
        { name: 'Доставка', value: data?.delivery.delivery_sum, type: 'price' },
        { name: 'ФИО покупателя:', value: data?.delivery.full_name },
        { name: 'Телефон', value: data?.delivery.phone },
        { name: 'Юзернэйм', value: data?.telegram_username, type: 'user' },
        { name: 'Адрес доставки:', value: data?.delivery.address },
        { name: 'Почта:', value: data?.delivery.email, type: 'link' },
        { name: 'Комментарий к заказу:', value: data?.delivery.description },
    ];
};

export const renderOrderInfo = (
    name: string,
    value: string | number,
    type?: string
) => {
    return (
        <Row>
            <Col span={12}>
                <Text>{name}</Text>
            </Col>
            <Col span={12}>
                {type === 'date' && (
                    <Text>{dayjs(value).format('DD.MM.YYYY')}</Text>
                )}
                {type === 'user' && value && <Link>@{value}</Link>}
                {type === 'link' && <Link>{value}</Link>}
                {type === 'price' && value !== null && (
                    <Text>
                        {value} {rub}
                    </Text>
                )}
                {type === undefined && <Text>{value}</Text>}
            </Col>
            <Divider style={{ margin: '16px 0' }} />
        </Row>
    );
};
